import React from 'react';
export default function TypeReality({handleTypeReality}) {
  return (
    <button key={"type-Reality"} className="type-Reality" onClick={handleTypeReality}>
    {" "}
    Reality{" "}
  </button>
  );
};